/* BabyOneStop search helpers (assets/bos-search.js)
 * 1. Normalizes queries before they reach Shopify search: trims/collapses
 *    whitespace (a padded " B00V73EWWG " returns 0 results) and compacts
 *    identifiers typed with spaces/hyphens (ASIN, UPC/EAN/GTIN).
 * 2. Autocomplete under the header search boxes (Shopify /search/suggest.json):
 *    image, title, brand, price/sale price, availability.
 * 3. Zero-result pages get real related products from a relaxed query.
 * ASINs are matched by a bare-ASIN product tag (see babyonestop_search_tags.py);
 * barcodes and SKUs are indexed by Shopify natively.
 */
(function () {
  if (window.__bosSearch) return; window.__bosSearch = true;
  var SEARCH = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'search';
  var money = function (cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(Number(cents)); }
    catch (e) { return '$' + Number(cents).toFixed(2); }
  };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  function normalize(q) {
    q = String(q || '').replace(/\s+/g, ' ').trim();
    var compact = q.replace(/[\s-]/g, '');
    if (/^B0[A-Z0-9]{8}$/i.test(compact)) return compact.toUpperCase();      // ASIN
    if (/^\d{8,14}$/.test(compact) && /^[\d\s-]+$/.test(q)) return compact;   // UPC / EAN / GTIN
    return q;
  }
  window.bosNormalizeQuery = normalize;

  /* ── 1. normalize on submit + fix padded URLs ── */
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.querySelector) return;
    var act = f.getAttribute('action') || '';
    if (!/\/search\/?$/.test(act)) return;
    var i = f.querySelector('input[name="q"]'); if (!i) return;
    var n = normalize(i.value);
    if (!n) { e.preventDefault(); i.focus(); return; }
    i.value = n;
  }, true);

  if (/\/search\/?$/.test(location.pathname)) {
    var u = new URL(location.href), raw = u.searchParams.get('q');
    if (raw != null && raw !== normalize(raw) && normalize(raw)) {
      u.searchParams.set('q', normalize(raw)); location.replace(u.toString()); return;
    }
  }

  /* ── styles ── */
  var css = document.createElement('style');
  css.textContent =
    '.bos-ac{position:fixed;z-index:2147483000;background:#fff;border-radius:16px;box-shadow:0 18px 48px rgba(23,59,86,.22);overflow:hidden;max-height:min(70vh,560px);overflow-y:auto;font-family:inherit;color:#173B56}' +
    '.bos-ac[hidden]{display:none}' +
    '.bos-ac__h{font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#5b7083;padding:12px 16px 6px}' +
    '.bos-ac__q{display:block;padding:8px 16px;font-size:14px;color:#173B56;text-decoration:none}' +
    '.bos-ac__p{display:flex;gap:12px;align-items:center;padding:8px 16px;text-decoration:none;color:#173B56}' +
    '.bos-ac__q[aria-selected=true],.bos-ac__p[aria-selected=true],.bos-ac__q:hover,.bos-ac__p:hover{background:#EEF6FD}' +
    '.bos-ac__img{flex:0 0 52px;width:52px;height:52px;border-radius:10px;background:#F4F7FA;overflow:hidden}' +
    '.bos-ac__img img,.bos-alt__i img{width:100%;height:100%;object-fit:contain;display:block}' +
    '.bos-ac__t{font-size:14px;line-height:1.3;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}' +
    '.bos-ac__m{font-size:12px;color:#5b7083;margin-top:2px}' +
    '.bos-ac__pr{font-weight:700;color:#173B56}.bos-ac__was{text-decoration:line-through;color:#8a9aa8;margin-left:6px;font-weight:400}' +
    '.bos-ac__oos{color:#b45309}.bos-ac__in{color:#15803d}' +
    '.bos-ac__all{display:block;padding:12px 16px;border-top:1px solid #E6EDF3;font-weight:700;color:#0071DC;text-decoration:none;font-size:14px}' +
    '.bos-ac__none{padding:14px 16px;font-size:14px;color:#5b7083}' +
    '.bos-alt{margin:28px 0 8px}.bos-alt h2{font-size:20px;margin:0 0 4px;color:#173B56}.bos-alt p{margin:0 0 16px;color:#5b7083;font-size:14px}' +
    '.bos-alt__g{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:16px}' +
    '@media (max-width:989px){.bos-alt__g{grid-template-columns:repeat(2,minmax(0,1fr));gap:12px}}' +
    '.bos-alt__c{display:flex;flex-direction:column;background:#fff;border:1px solid #E6EDF3;border-radius:14px;padding:12px;text-decoration:none;color:#173B56}' +
    '.bos-alt__c:hover{box-shadow:0 8px 24px rgba(23,59,86,.12)}' +
    '.bos-alt__i{aspect-ratio:1/1;border-radius:10px;background:#F4F7FA;overflow:hidden;margin-bottom:10px}' +
    '.bos-alt__tips{margin-top:14px;font-size:13px;color:#5b7083}';
  document.head.appendChild(css);

  function thumb(p, w) {
    var u = p.featured_image && p.featured_image.url || p.image || '';
    if (!u) return '';
    return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  }
  function imgTag(p, cls, w) {
    var u = thumb(p, w);
    return '<span class="' + cls + '">' + (u ? '<img src="' + esc(u) + '" alt="" loading="lazy" decoding="async">' : '') + '</span>';
  }
  function productRow(p, id) {
    var sale = p.compare_at_price_max && Number(p.compare_at_price_max) > Number(p.price);
    return '<a class="bos-ac__p" role="option" id="' + id + '" href="' + esc(p.url) + '">' + imgTag(p, 'bos-ac__img', 120) +
      '<span><span class="bos-ac__t">' + esc(p.title) + '</span>' +
      '<span class="bos-ac__m">' + (p.vendor ? esc(p.vendor) + ' · ' : '') +
      '<span class="bos-ac__pr">' + money(p.price) + '</span>' + (sale ? '<span class="bos-ac__was">' + money(p.compare_at_price_max) + '</span>' : '') +
      ' · <span class="' + (p.available ? 'bos-ac__in">In stock' : 'bos-ac__oos">Out of stock') + '</span></span></span></a>';
  }

  function suggest(q, limit) {
    return fetch(SEARCH + '/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,query&resources[limit]=' + (limit || 6) +
      '&resources[options][unavailable_products]=last', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { return d && d.resources && d.resources.results || { products: [], queries: [] }; })
      .catch(function () { return { products: [], queries: [] }; });
  }

  /* ── 2. autocomplete ── */
  function attach(input) {
    if (input.__bosAc) return; input.__bosAc = true;
    var form = input.form, box = document.createElement('div'), timer, seq = 0, sel = -1;
    box.className = 'bos-ac'; box.hidden = true; box.setAttribute('role', 'listbox');
    box.id = 'bos-ac-' + Math.random().toString(36).slice(2, 8);
    document.body.appendChild(box);
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-controls', box.id); input.setAttribute('aria-autocomplete', 'list');
    function place() {
      var r = (form || input).getBoundingClientRect();
      box.style.left = Math.max(8, r.left) + 'px';
      box.style.top = (r.bottom + 6) + 'px';
      box.style.width = Math.min(r.width, window.innerWidth - 16) + 'px';
    }
    function close() { box.hidden = true; sel = -1; input.setAttribute('aria-expanded', 'false'); }
    function items() { return box.querySelectorAll('.bos-ac__q,.bos-ac__p'); }
    function mark() {
      var it = items();
      for (var i = 0; i < it.length; i++) it[i].setAttribute('aria-selected', i === sel ? 'true' : 'false');
      if (it[sel]) { input.setAttribute('aria-activedescendant', it[sel].id); it[sel].scrollIntoView({ block: 'nearest' }); }
    }
    function run() {
      var q = normalize(input.value);
      if (q.length < 2) { close(); return; }
      var my = ++seq;
      suggest(q, 6).then(function (res) {
        if (my !== seq) return;
        var html = '', n = 0;
        var qs = (res.queries || []).filter(function (x) { return x.text && x.text.toLowerCase() !== q.toLowerCase(); }).slice(0, 4);
        if (qs.length) {
          html += '<div class="bos-ac__h">Suggestions</div>';
          qs.forEach(function (x) { html += '<a class="bos-ac__q" role="option" id="' + box.id + '-' + (n++) + '" href="' + esc(SEARCH + '?q=' + encodeURIComponent(x.text)) + '">' + (x.styled_text || esc(x.text)) + '</a>'; });
        }
        if ((res.products || []).length) {
          html += '<div class="bos-ac__h">Products</div>';
          res.products.forEach(function (p) { html += productRow(p, box.id + '-' + (n++)); });
        }
        if (!n) html += '<div class="bos-ac__none">No matching products yet — press Enter to search all.</div>';
        html += '<a class="bos-ac__all" href="' + esc(SEARCH + '?q=' + encodeURIComponent(q)) + '">See all results for “' + esc(q) + '” →</a>';
        box.innerHTML = html; sel = -1; place(); box.hidden = false; input.setAttribute('aria-expanded', 'true');
      });
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 180); });
    input.addEventListener('focus', function () { if (input.value.trim().length >= 2) run(); });
    input.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      var it = items();
      if (e.key === 'ArrowDown') { e.preventDefault(); sel = Math.min(sel + 1, it.length - 1); mark(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); sel = Math.max(sel - 1, -1); mark(); }
      else if (e.key === 'Enter' && sel >= 0 && it[sel]) { e.preventDefault(); location.href = it[sel].href; }
      else if (e.key === 'Escape') { close(); }
    });
    document.addEventListener('click', function (e) { if (e.target !== input && !box.contains(e.target)) close(); });
    window.addEventListener('resize', function () { if (!box.hidden) place(); });
    window.addEventListener('scroll', function () { if (!box.hidden) place(); }, { passive: true });
  }
  function scan() {
    var ins = document.querySelectorAll('form[action$="/search"] input[name="q"]');
    for (var i = 0; i < ins.length; i++) if (!ins[i].closest('#MainContent, predictive-search, .predictive-search')) attach(ins[i]);
  }

  /* ── 3. related products on zero results ── */
  function alternatives() {
    var empty = document.querySelector('.template-search--empty');
    var q = normalize(new URLSearchParams(location.search).get('q'));
    if (!empty || !q) return;
    var words = q.split(' ').filter(function (w) { return w.length > 2; });
    var tries = [];
    if (words.length > 1) { tries.push(words.slice(0, 3).join(' ')); tries.push(words.slice(-2).join(' ')); }
    words.forEach(function (w) { tries.push(w); });
    var tips = '<div class="bos-alt__tips">Tip: you can search by product name, brand, Amazon ASIN, UPC/barcode or SKU.</div>';
    var anchor = empty.querySelector('[role="status"]');
    var wrap = document.createElement('div'); wrap.className = 'bos-alt';
    (function next(i) {
      if (i >= tries.length) { wrap.innerHTML = tips; if (anchor) anchor.after(wrap); return; }
      suggest(tries[i], 8).then(function (res) {
        var ps = (res.products || []).slice(0, 8);
        if (!ps.length) return next(i + 1);
        wrap.innerHTML = '<h2>You might be looking for</h2><p>Related products for “' + esc(tries[i]) + '”</p><div class="bos-alt__g">' +
          ps.map(function (p) {
            var sale = p.compare_at_price_max && Number(p.compare_at_price_max) > Number(p.price);
            return '<a class="bos-alt__c" href="' + esc(p.url) + '">' + imgTag(p, 'bos-alt__i', 400) +
              '<span class="bos-ac__t">' + esc(p.title) + '</span><span class="bos-ac__m">' + (p.vendor ? esc(p.vendor) : '') + '</span>' +
              '<span class="bos-ac__m"><span class="bos-ac__pr">' + money(p.price) + '</span>' + (sale ? '<span class="bos-ac__was">' + money(p.compare_at_price_max) + '</span>' : '') +
              ' · <span class="' + (p.available ? 'bos-ac__in">In stock' : 'bos-ac__oos">Out of stock') + '</span></span></a>';
          }).join('') + '</div>' + tips;
        if (anchor) anchor.after(wrap); else empty.appendChild(wrap);
      });
    })(0);
  }

  function init() { scan(); alternatives(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
